var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06748 4.76667C5.26006 3.37832 7.02765 2.5 9.00012 2.5C12.59 2.5 15.5001 5.41015 15.5001 9C15.5001 12.5899 12.59 15.5 9.00012 15.5C5.41027 15.5 2.50012 12.5899 2.50012 9C2.50012 8.72386 2.27626 8.5 2.00012 8.5C1.72398 8.5 1.50012 8.72386 1.50012 9C1.50012 13.1421 4.85799 16.5 9.00012 16.5C13.1423 16.5 16.5001 13.1421 16.5001 9C16.5001 4.85786 13.1423 1.5 9.00012 1.5C6.71666 1.5 4.67187 2.52073 3.29678 4.12933L2.95048 2.80669C2.88054 2.53955 2.60728 2.37969 2.34015 2.44964C2.07301 2.51958 1.91315 2.79284 1.98309 3.05998L2.69177 5.76667H5.26679C5.54293 5.76667 5.76679 5.54281 5.76679 5.26667C5.76679 4.99052 5.54293 4.76667 5.26679 4.76667H4.06748ZM9.5 4C9.5 3.72386 9.27614 3.5 9 3.5C8.72386 3.5 8.5 3.72386 8.5 4V9.20711L11.1464 11.8536C11.3417 12.0488 11.6583 12.0488 11.8536 11.8536C12.0488 11.6583 12.0488 11.3417 11.8536 11.1464L9.5 8.79289V4Z",
    fill: "#606568"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.5a67140c42196527e9036ff1b94f7cac.svg";
export { ForwardRef as ReactComponent };